import React from 'react'

const TrunkSaleRibbonBasic = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 189.45 32">
            <g data-name="Layer 2">
                <g data-name="Layer 1 copy 6">
                    <path fill="#fdf4d9" d="M0 0H158.93V32H0z"></path>
                    <path
                        fill="#fdf4d9"
                        d="M157.45 32L189.45 0 157.45 0 157.45 32z"
                    ></path>
                    <path
                        fill="#fdf4d9"
                        d="M158.45 32L188.45 32 158.45 0 158.45 32z"
                    ></path>
                    <path
                        fill="#6b5788"
                        d="M12.65 11.72V9.66h10.24v2.06h-4v10.54h-2.22V11.72zM25.68 22.26V9.66h5.62a5 5 0 013.64 1.26 3.77 3.77 0 011 2.72 3.72 3.72 0 01-.8 2.45 4.33 4.33 0 01-2.14 1.4l3.4 4.77h-2.63l-3.1-4.39H27.9v4.39zm2.22-6.35h3.24a2.87 2.87 0 001.86-.58 1.86 1.86 0 00.7-1.53 1.87 1.87 0 00-.68-1.54 3.06 3.06 0 00-1.93-.54H27.9zM38.94 16.92V9.66h2.22v7.17a3.82 3.82 0 00.84 2.66 3.46 3.46 0 004.67 0 3.65 3.65 0 00.84-2.6V9.66h2.22v7.14a5.68 5.68 0 01-1.45 4.2 5.34 5.34 0 01-4 1.45A5.35 5.35 0 0140.37 21a5.58 5.58 0 01-1.43-4.08zM53.21 22.26V9.66h2.06L62 18.38V9.66h2.2v12.6h-1.86l-7-9v9zM67.87 22.26V9.66h2.22V16l6-6.34h2.74l-5.26 5.42 5.49 7.18h-2.7l-4.3-5.67-2 2v3.65zM86.39 20.43l1.33-1.59a7.13 7.13 0 001.9 1.23 5.25 5.25 0 002.08.41 2.71 2.71 0 001.62-.48 1.33 1.33 0 00.61-1.14 1.33 1.33 0 00-.22-.78 2.11 2.11 0 00-.84-.6 9.18 9.18 0 00-1.78-.54 12.92 12.92 0 01-1.47-.43 7.14 7.14 0 01-1.16-.51 3.25 3.25 0 01-.87-.68 3.06 3.06 0 01-.52-.92 3.88 3.88 0 01-.18-1.23 3.28 3.28 0 011.21-2.67 4.61 4.61 0 013.09-1 7 7 0 014.57 1.59l-1.18 1.67a5.82 5.82 0 00-3.42-1.3 2.43 2.43 0 00-1.5.43 1.3 1.3 0 00-.56 1.07 1.34 1.34 0 00.25.83 2.32 2.32 0 00.89.6 12.18 12.18 0 001.87.56 7.56 7.56 0 013.06 1.34 2.89 2.89 0 011 2.34 3.36 3.36 0 01-1.24 2.75 5 5 0 01-3.26 1 7.63 7.63 0 01-5.28-1.95zM97.84 22.26l5.55-12.69h2L111 22.26h-2.34l-1.27-3h-6l-1.3 3zm4.38-5h4.34l-2.18-5zM113.58 22.26V9.66h2.22v10.58h6.62v2zM125.17 22.26V9.66h9.34v2h-7.13v3.32h6.32v2h-6.32v3.4h7.22v2z"
                    ></path>
                </g>
            </g>
        </svg>
    )
}

export default TrunkSaleRibbonBasic
